import { Link } from "react-router-dom"
import { Space } from "../Layout"
import { Media, Texts, Title, Button } from "../Object"
import { Scroll } from "../Animation"

const Service = (props) => {
  return(
    <>
      <Space size={['120px', '0px']}></Space>
      <div className="l-row">
        <div className="c-grid__wrap--media-content">
        
        <Media src="service/main" class="p-img--service" alt="main"></Media>
          
        <div>
          <Title slug="service" type="" />
          <Space size={['48px 0 64px', '40px 0']}>
            <Texts slug="service/body"></Texts>
          </Space>
          <Button slug="more" type="end"></Button>
        </div>
        </div>
      </div>
      <Space size={['160px', '80px']}></Space>
    
      <List />
      
      <Space size={['160px', '80px']}></Space>
    </>
  )
  
}


export const List = (props) => {
  const args = {
    slug: "service",
    length: 4,
  };
  const Item = (props) => {
    return (
      <>
        <Scroll>
          <li className="items c-grid__items--service">
            <Media src={`service/sample-list${props.index}`} alt="media"></Media>
          </li>
        </Scroll>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i}></Item>);
  }

  return (
    <>
      <div className="l-row">
        <div className="c-grid--center">
          <Title slug="sample" enClass="c-text--center" jpClass="c-text--center"></Title>
        </div>
        <Space size={['80px 0 0', '40px 0 0']}>
          <ul className="list c-grid__wrap--repeat-4">{items}</ul>
        </Space>
      </div>
    </>
  );
};

export default Service;